module.exports = __webpack_public_path__ + "08b6247e28dae14d573ed940bf1337b7.svg";